<template>
  <div>
    <el-upload
      class="upload-demo"
      :action="action"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :on-success="handleSuccess"
      :file-list="fileList"
      :limit="limit"
      :data="{ category: param }"
      v-bind="$attrs"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">{{ tips }}</div>
    </el-upload>
  </div>
</template>

<script>
import utils from 'my-tools-library'
import request from '@/utils/service'

export default {
  props: {
    maxSize: {
      type: String,
      default: ''
    },
    param: {
      type: String,
      default: 'PDF'
    },
    limit: {
      type: Number,
      default: 0
    },
    value: {
      type: [Array, String],
      default: () => []
    },
    tips: {
      type: String,
      default: '只能上传PDF文件'
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.fileList = utils.handleJsonImg(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      action: `${request.defaults.baseURL}/common/uploadFile`,
      fileList: []
    }
  },
  methods: {
    handleRemove(file) {
      this.$emit('delFile', file)
    },
    handlePreview(file) {
      this.$emit('clickFile', file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },

    handleSuccess(response) {
      this.$emit('success', response)
    },
    beforeUpload(file) {
      const fileSize = file.size / 1024
      if (this.maxSize) {
        console.log('fileSize :>> ', fileSize, this.maxSize)
        if (fileSize > this.maxSize) {
          this.$message.error(`最大可上传${this.maxSize}kb的文件`)
          return false
        }
      }
      // console.log('file :>> ', file, utils.getExt(file.name))
      return true
    }
  }
}
</script>

<style lang="scss" scoped></style>
